
<h1>{{tipo=='edit' ? 'Editar' : 'Agregar'}} Centros de Costo</h1>
<form [formGroup]="form" (submit)="submit()" class="form-horizontal" novalidate>
  <fieldset>

    <div *ngIf="tipo=='save'" class="form-group"  [ngClass]="{'has-error': (form.get('orden_ceco').touched || form.get('orden_ceco').dirty) && !form.get('orden_ceco').valid }">
      <label class="col-md-2 control-label" for="nombre">ID Planta</label>
      <div class="col-md-8">
        <input class="form-control" id="orden_ceco" type="text" required   formControlName="orden_ceco"  />
        <span class="alert alert-danger" *ngIf="(form.get('orden_ceco').touched || form.get('orden_ceco').dirty) && form.get('orden_ceco').errors">
          <span *ngIf="form.get('orden_ceco').errors.required">
            El campo ID Centro de costo es requerido
          </span>
        </span>
      </div>
    </div>

    <div class="form-group"  [ngClass]="{'has-error': (form.get('nombre_ceco').touched || form.get('nombre_ceco').dirty) && !form.get('nombre_ceco').valid }">
      <label class="col-md-2 control-label" for="nombre">Nombre</label>
      <div class="col-md-8">
        <input class="form-control" id="nombre_ceco" type="text" required   formControlName="nombre_ceco" />
        <span class="alert alert-danger" *ngIf="(form.get('nombre_ceco').touched || form.get('nombre_ceco').dirty) && form.get('nombre_ceco').errors">
          <span *ngIf="form.get('nombre_ceco').errors.required">
            El campo nombre es requerido
          </span>
        </span>
      </div>
    </div>




    <div class="form-group">
      <div class="col-md-4 col-md-offset-2">
        <span>
          <button class="btn btn-primary"   [disabled]="!form.valid"> Salvar  </button>
          <button class="btn btn-primary" (click)="closeMyModal(false)">Cerrar Modal</button>

        </span>

      </div>

    </div>
  </fieldset>
</form>

